import * as React from 'react';

export function useGetAppIdForMessageAfterDownloadInstaller(downloadLink?: string) {
  const [appId, setAppId] = React.useState<number | undefined>();

  React.useEffect(() => {
    if (!downloadLink) {
      return;
    }

    const appIdFromLink = getQueryParamAppId(downloadLink);
    setAppId(appIdFromLink);
  }, [downloadLink]);

  return appId;
}

function getQueryParamAppId(link: string) {
  const regex = new RegExp(/appId=([^&#]*)/);
  const result = link.match(regex);

  if (result && result[1]) {
    return Number(result[1]);
  }

  return 0;
}
